'use client';

import {
  BottomSheetHandleArea,
  BottomSheetTitle,
  BottomSheetTitleBox,
  BottomSheetTitleContainer,
  Dim,
  DropdownTriggerArrowCloseIconButton,
  DropdownTriggerArrowOpenIconButton,
  DropdownTriggerBox,
  DropdownTriggerInput,
  IcBoldClose,
  IconButton,
  Sheet,
  SheetContent,
  SheetDimMotion,
  SheetMotion,
  SheetPortal,
  SheetTrigger,
  Typography,
} from '@musinsa/mds';
import { useState } from 'react';
import { SETTLEMENT_FORM_SCHEMA } from './settlement-form.schema';
import type { BusinessType } from './types';

interface BusinessTypeFieldProps {
  value?: BusinessType;
  onChange?: (value: BusinessType) => void;
  error?: boolean;
  errorText?: string;
}

export const BusinessTypeField = ({
  value = 'NATURAL_PERSON', // 기본값: 개인
  onChange,
  error,
  errorText,
}: BusinessTypeFieldProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedOption = SETTLEMENT_FORM_SCHEMA.businessTypeOptions.find(
    (option) => option.value === value,
  );

  const handleSelect = (optionValue: string) => {
    onChange?.(optionValue as BusinessType);
    setIsOpen(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="flex flex-col gap-2 py-2">
      <Typography size="14" weight="medium">
        유형
      </Typography>

      <Sheet direction="bottom" open={isOpen}>
        <SheetTrigger
          asChild
          onClick={(e) => {
            e.preventDefault();
            setIsOpen(true);
          }}
        >
          <DropdownTriggerBox>
            <DropdownTriggerInput value={selectedOption?.label || '개인'} readOnly />
            <DropdownTriggerArrowOpenIconButton />
            <DropdownTriggerArrowCloseIconButton />
          </DropdownTriggerBox>
        </SheetTrigger>
        <SheetPortal>
          <SheetContent onPointerDownOutside={handleClose}>
            <SheetMotion direction="bottom">
              <BottomSheetTitle>
                <BottomSheetHandleArea />
                <BottomSheetTitleContainer className="px-4 py-2">
                  <BottomSheetTitleBox>유형 선택</BottomSheetTitleBox>
                  <IconButton size="size28x28" onClick={handleClose}>
                    <IcBoldClose strokeColor="black" />
                  </IconButton>
                </BottomSheetTitleContainer>
              </BottomSheetTitle>

              <div className="max-h-[532px] safe-area-bottom bg-white overflow-y-auto">
                <div>
                  {SETTLEMENT_FORM_SCHEMA.businessTypeOptions.map((option) => (
                    <button
                      type="button"
                      key={option.value}
                      className="w-full px-4 py-3 cursor-pointer first:pt-1 text-left"
                      onClick={() => handleSelect(option.value)}
                    >
                      <Typography
                        className="py-[11px]"
                        colorScheme={value === option.value ? 'black' : 'gray-600'}
                        variant={value === option.value ? 'body13pxMed' : 'body13pxReg'}
                      >
                        {option.label}
                      </Typography>
                    </button>
                  ))}
                </div>
              </div>
            </SheetMotion>
          </SheetContent>
          <SheetDimMotion>
            <Dim />
          </SheetDimMotion>
        </SheetPortal>
      </Sheet>
      {error && errorText && (
        <Typography size="11" className="text-red leading-[14px] ml-2">
          {errorText}
        </Typography>
      )}
    </div>
  );
};
